import { motion } from "framer-motion";
import { Building2, SlidersHorizontal, Rocket } from "lucide-react";

const steps = [
    {
        n: "01",
        icon: Building2,
        title: "Vi importerer alt — gratis",
        desc: "Send os jeres Excel-ark over kunder, medarbejdere og lokationer. Vi importerer det hele på dag 1. Onboarding-session: 1 time med din servicechef.",
    },
    {
        n: "02",
        icon: SlidersHorizontal,
        title: "Tilpas dine moduler",
        desc: "Slå moduler til og fra som I har brug for. Betal kun for det I bruger.",
    },
    {
        n: "03",
        icon: Rocket,
        title: "Live efter 1 uge",
        desc: "Køreopgaver, kvalitet, fakturering og rapporter — alt sker automatisk. Slut med papir og Excel.",
    },
];

export default function HowItWorks() {
    return (
        <section
            id="sadan-virker-det"
            className="py-24 md:py-32 bg-slate-50/60 border-y border-slate-200/70"
            data-testid="how-it-works-section"
        >
            <div className="max-w-7xl mx-auto px-6 lg:px-10">
                <div className="max-w-3xl">
                    <div className="inline-flex items-center gap-2 rounded-full bg-white border border-slate-200 px-3 py-1 text-xs font-semibold text-slate-700">
                        <span className="h-1.5 w-1.5 rounded-full bg-sky-500" /> Sådan virker det
                    </div>
                    <h2 className="mt-5 font-display text-3xl md:text-5xl font-bold tracking-tight text-slate-900">
                        Fra papir til platform — på under en uge.
                    </h2>
                </div>

                <div className="mt-14 grid md:grid-cols-3 gap-6">
                    {steps.map((s, i) => (
                        <motion.div
                            key={s.n}
                            initial={{ opacity: 0, y: 24 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.55, delay: i * 0.1 }}
                            className="relative rounded-2xl bg-white border border-slate-200 p-8 overflow-hidden"
                            data-testid={`step-${s.n}`}
                        >
                            <span className="absolute -top-4 -right-2 font-display text-[7rem] font-black text-sky-100/80 select-none leading-none">
                                {s.n}
                            </span>
                            <div className="relative h-12 w-12 rounded-xl bg-sky-600 text-white flex items-center justify-center shadow-md shadow-sky-500/20">
                                <s.icon className="h-5 w-5" strokeWidth={2} />
                            </div>
                            <h3 className="relative mt-6 font-display text-xl font-semibold text-slate-900">
                                {s.title}
                            </h3>
                            <p className="relative mt-2 text-sm text-slate-600 leading-relaxed">
                                {s.desc}
                            </p>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
}
